<mat-toolbar class="">  
    <mat-toolbar-row   color="primary" class="theme-container toolbar first-toolbar">
      <span class="left-spacer"></span>
      <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">
        <div fxFlex fxHide fxShow.gt-sm>
          <span class="hvr-underline-reveal" [routerLink]="['/class-websites']" >班級網頁</span>
        </div>
        <div fxFlex fxHide fxShow.gt-xs>
          <span class="hvr-underline-reveal" [routerLink]="['/phone-extension']" >電話分機</span>
        </div>
        <div fxFlex fxHide fxShow.gt-sm>
          <span class="hvr-underline-reveal" [routerLink]="['/schedule']">學期行事曆</span>
        </div>
        <div fxFlex fxHide fxShow.gt-sm>
          <span class="hvr-underline-reveal" [routerLink]="['/sexual-harassment']">性騷擾處置</span>
        </div>
      </div>
      
     

    </mat-toolbar-row>
    <mat-toolbar-row  class="theme-container toolbar second-toolbar">
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="0px">
        <div fxFlex=65 fxFlexAlign="center" class="top-title " routerLink="/">
          <div class="hvr-underline-reveal">
            澎湖縣馬公市中正國民小學
          </div>
        </div>
        <div fxFlex=35 fxHide fxShow.gt-sm fxFlexAlign="end" class="top-subtitle">
          我們努力營造優良之學習環境，增進學生思考、表達、閱讀、寫作之基本能力。
        </div>
      </div>

    </mat-toolbar-row>
  </mat-toolbar>